/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AllergyService } from './services/allergy.service';
import { ApiKeysService } from './services/api-keys.service';
import { AppointmentService } from './services/appointment.service';
import { AppPreferencesService } from './services/app-preferences.service';
import { AppSettingService } from './services/app-setting.service';
import { AuditService } from './services/audit.service';
import { AuthService } from './services/auth.service';
import { BillingService } from './services/billing.service';
import { ColumnChooserService } from './services/column-chooser.service';
import { ConfigSettingService } from './services/config-setting.service';
import { DocumentService } from './services/document.service';
import { ExportDocumentsService } from './services/export-documents.service';
import { FinancialService } from './services/financial.service';
import { GlobalMappingSettingsService } from './services/global-mapping-settings.service';
import { GlobalSettingsService } from './services/global-settings.service';
import { ImageService } from './services/image.service';
import { LabsService } from './services/labs.service';
import { MedicationService } from './services/medication.service';
import { NotesTemplateService } from './services/notes-template.service';
import { OrderClassService } from './services/order-class.service';
import { OrderService } from './services/order.service';
import { PatientArchiveService } from './services/patient-archive.service';
import { PatientService } from './services/patient.service';
import { PatientDemographicsService } from './services/patient-demographics.service';
import { PracticesService } from './services/practices.service';
import { ProblemService } from './services/problem.service';
import { RecentlyVisitedService } from './services/recently-visited.service';
import { ReportCategoryService } from './services/report-category.service';
import { ReportParamService } from './services/report-param.service';
import { ReportsService } from './services/reports.service';
import { RolesService } from './services/roles.service';
import { SecurityAnswersService } from './services/security-answers.service';
import { SecurityQuestionService } from './services/security-question.service';
import { SsoService } from './services/sso.service';
import { TransactionService } from './services/transaction.service';
import { TwoFactorService } from './services/two-factor.service';
import { UserService } from './services/user.service';
import { UserPracticesService } from './services/user-practices.service';
import { UserPreferenceSettingService } from './services/user-preference-setting.service';
import { VisitsService } from './services/visits.service';
import { VitalService } from './services/vital.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AllergyService,
    ApiKeysService,
    AppointmentService,
    AppPreferencesService,
    AppSettingService,
    AuditService,
    AuthService,
    BillingService,
    ColumnChooserService,
    ConfigSettingService,
    DocumentService,
    ExportDocumentsService,
    FinancialService,
    GlobalMappingSettingsService,
    GlobalSettingsService,
    ImageService,
    LabsService,
    MedicationService,
    NotesTemplateService,
    OrderClassService,
    OrderService,
    PatientArchiveService,
    PatientService,
    PatientDemographicsService,
    PracticesService,
    ProblemService,
    RecentlyVisitedService,
    ReportCategoryService,
    ReportParamService,
    ReportsService,
    RolesService,
    SecurityAnswersService,
    SecurityQuestionService,
    SsoService,
    TransactionService,
    TwoFactorService,
    UserService,
    UserPracticesService,
    UserPreferenceSettingService,
    VisitsService,
    VitalService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
